import { createContext } from 'react';
import { BusinessLevel } from '../interfaces/business-level.interface';

export interface ISelectedBusinessLevelContext {
  selectedBusinessLevel: BusinessLevel | null;
}

export const SelectedBusinessLevelContext = createContext<ISelectedBusinessLevelContext>({
  selectedBusinessLevel: null,
});